import BaseService from './../base'

export default class AccountGroupsService extends BaseService {
  static resource() {
    return 'api/v1/external/accountGroups'
  }
}
